import animadoAlAparecer from "./lib/animado-al-aparecer";
import formulario from "./lib/formulario";
import bloques from "./aniversario/bloques";
require('../sass/app.scss');
const ajustaVw = () => {
    document.documentElement.style.setProperty('--vw', `${document.documentElement.clientWidth}px`);
};
const dataLayer = window.dataLayer;
addEventListener('resize', ajustaVw);
addEventListener('load', ajustaVw);
ajustaVw();
bloques();
animadoAlAparecer('.animado');
formulario('form', {
    dataLayer,
    ocultarEtiquetas: true
});
